// ── RateSellerModal.jsx ───────────────────────────────────────────────────────
// Sub-modal: rate the seller with a star picker and optional comment

import React from 'react';
import styles from '../ProductDetailModal.module.css';

const RATING_LABELS = ['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];

const RateSellerModal = ({
  product,
  userRating,
  setUserRating,
  hoverRating,
  setHoverRating,
  ratingComment,
  setRatingComment,
  ratingSuccess,
  ratingError,
  setRatingError,
  isSubmittingRating,
  onSubmit,
  onClose,
}) => {
  return (
    <div
      className={styles.offerModalOverlay}
      onClick={() => !isSubmittingRating && onClose()}
    >
      <div className={styles.offerModal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.offerCloseBtn}
          onClick={onClose}
          disabled={isSubmittingRating}
        >
          ×
        </button>

        <h3>Rate this Seller</h3>
        <p className={styles.offerModalSubtitle}>
          Seller: <strong>{product.seller}</strong>
        </p>

        {ratingSuccess && <div className={styles.successBanner}>{ratingSuccess}</div>}
        {ratingError   && <div className={styles.errorBanner}>{ratingError}</div>}

        {/* Star picker */}
        <div className={styles.offerInputGroup}>
          <label>Your Rating</label>
          <div className={styles.starPicker}>
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                className={`${styles.starBtn} ${(hoverRating || userRating) >= star ? styles.starActive : ''}`}
                onMouseEnter={() => setHoverRating(star)}
                onMouseLeave={() => setHoverRating(0)}
                onClick={() => {
                  setUserRating(star);
                  if (ratingError) setRatingError('');
                }}
                disabled={isSubmittingRating}
                title={`${star} star${star > 1 ? 's' : ''}`}
              >
                ★
              </button>
            ))}
            <span className={styles.ratingLabel}>
              {(hoverRating || userRating) > 0
                ? RATING_LABELS[hoverRating || userRating]
                : 'Select rating'}
            </span>
          </div>
        </div>

        {/* Optional comment */}
        <div className={styles.offerInputGroup}>
          <label>Comment (Optional)</label>
          <textarea
            className={styles.offerTextarea}
            placeholder="Share your experience with this seller..."
            value={ratingComment}
            onChange={(e) => setRatingComment(e.target.value)}
            rows="3"
            disabled={isSubmittingRating}
          />
        </div>

        <div className={styles.offerModalButtons}>
          <button
            className={styles.offerSubmitBtn}
            onClick={onSubmit}
            disabled={isSubmittingRating || userRating === 0}
          >
            {isSubmittingRating ? 'Submitting...' : 'Submit Rating'}
          </button>
          <button
            className={styles.offerCancelBtn}
            onClick={onClose}
            disabled={isSubmittingRating}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateSellerModal;
